<template>
  <div class="have2Leave">
    <div class="wait">
      <div class="title">{{ $t('lang.account.wait') }}</div>
      <div class="desc">{{ $t('lang.account.bigWin')[0] }}<span class="bigFont">{{
          $t('lang.account.bigWin')[1]
        }}</span>!
      </div>
      <div class="center">
        <img :src="coins" alt=""/>
      </div>
      <div class="buttons">
        <div class="btn1" @click="closeWait">{{ $t('lang.account.continue2Pay') }}</div>
        <div class="btn2" @click="gotoNextRoute">{{ $t('lang.account.dontCare') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import coins from '@/assets/images/account/coins.png'
import {LogUtils} from '@/utils'

export default {
  name: 'WaitModal',
  props: ['userInfo'],
  data () {
    return {
      coins
    }
  },
  methods: {
    open () {
      this.$store.commit('setWaitShow', true)
    },
    closeWait () {
      LogUtils.saveUserEvent('DepositMonitoring5', this.userInfo.UserId)
      this.$emit('closed')
    },
    gotoNextRoute () {
      LogUtils.saveUserEvent('DepositMonitoring6', this.userInfo.UserId)
      this.$emit('navigate')
    }
  }
}
</script>

<style lang="less" scoped>
.have2Leave {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;

  .wait {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 86.666vw;
    height: 90.555vw;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
    border: 0.3vw solid #737373;
    border-radius: 4.166vw;

    .title {
      margin-top: 4.722vw;
      font-size: 5.833vw;
      font-weight: 700;
      text-align: center;
      color: #FFFFFF;
    }

    .desc {
      margin-top: 6vw;
      font-size: 4.722vw;
      font-weight: 400;
      letter-spacing: -0.05em;
      text-align: center;
      color: #C4C4C4;

      .bigFont {
        font-size: 5.277vw;
        font-weight: 700;
        letter-spacing: -0.05em;
        text-align: center;
        color: #DEBC86;
      }
    }

    .center {
      margin: -7.5vw auto 0 auto;
      width: 51.388vw;
      height: 40vw;
      overflow: hidden;
      display: flex;
      align-items: flex-start;

      img {
        width: 51.388vw;
        height: 48.0555vw;
      }
    }

    .buttons {
      margin: 5vw auto 0 auto;
      width: 65.883vw;
      height: max-content;
      text-align: center;
      line-height: 10vw;
      font-size: 4.166vw;
      font-weight: 600;

      .btn1 {
        width: 65.883vw;
        border-radius: 1.388vw;
        height: 10vw;
        background: linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        color: #000000;
      }

      .btn2 {
        margin-top: 3.333vw;
        width: 65.883vw;
        border-radius: 1.388vw;
        height: 10vw;
        border: 0.3vw solid #E2C28F;
        color: #E1C18D;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WaitModal/index.vue